import vueComponentOptions from 'components/InputPickLayer.vue';

const PickLayerInput = Vue.extend(vueComponentOptions);

module.exports = PickLayerInput;
